<!--
 * @Description: Do not edit
 * @Author: 蒙川
 * @Date: 2019-03-15 09:04:37
 * @LastEditors  : 蒙川
 * @LastEditTime : 2020-01-14 11:17:11
 -->
<template>
  <div>
    <div class="section">
      <h5 class="name" v-text="name"></h5>
      <div class="content" v-html="content"></div>
    </div>
  </div>
</template>
<script>
import api from '@/script/util'
import '@/style/frozen.css'
import '@/style/base.css'

// type协议类型

// 1   APP用户端帮助
// 2   安全协议
// 3   关于（业主端）
// 4   关于（商家端）
// 5   关于（物管端）
// 6   积分说明
// 7   快递代收协议
// 8   停车申请用户帮助手册
// 9   隐私权政策
// 10  鹰眼监控须知
// 11  用户个人信息协议
// 12  用户协议
// 13  智能开门须知
// 14  增票资质确认书
// 15  组织成员管理说明
// 16  组织对外代表说明
// 17  组织用户帮助手册
// 18  组织账户管理说明
// 19  红包说明
// 20  工作室公约
// 21  装修协议
// 22  发票须知
// 23  健康隐私协议
// 24  商家入驻协议（业主端）
// 25  物管端软件许可协议（Android）
// 26  物管端软件许可协议（iOS）
// 27  商家端软件许可协议（Android）
// 28  商家端软件许可协议（iOS）
// 29  用户端软件许可协议（Android）
// 30  用户端软件许可协议（iOS）

export default {
  name: '',
  data () {
    return {
      content: '',
      name: ''
    }
  },
  created: function () {
    // 特殊处理业主端关于
    let type = api.getVal('type')
    let redirect = api.getVal('redirect')
    let level = api.getVal('level') // 层级
    if (level === '2') {
      // app级协议
      this.getAppProtocolDetail()
    } else {
      if (type === '8') {
        this.getCarParkProtocol()
      } else if (type === '3' && redirect !== '1') {
        this.$router.replace({
          name: 'aboutProtocol',
          query: {
            ...this.$route.query
          }
        })
      } else {
        this.getProtocolDetail()
      }
    }
  },
  methods: {
    // 通用协议
    getProtocolDetail: async function () {
      let type = api.getVal('type')
      let communityId = api.getVal('defCommunityId')
      let regionId = api.getVal('regionId')
      let url = 'appInfo/getAppAgreementInfo'
      const { data } = await api.getProtocolDetail(url, { agreementType: type, communityId, regionId })
      if (data) {
        this.content = data.agreementDoc
        this.name = data.agreementName
      }
    },
    // 停车协议
    async getCarParkProtocol () {
      let carParkSuitId = api.getVal('carParkSuitId')
      let url = `carParkApplication/carParkSuit/${carParkSuitId}/getProtocol`
      const { data } = await api.getProtocolDetail(url)
      if (data) {
        this.content = data
      }
      if (window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge.callHandler('_app_setTitle', '停车协议')
      }
    },
    // 获取APP级协议
    async getAppProtocolDetail () {
      let type = api.getVal('type')
      let mobileType = api.getVal('mobileType')
      let url = 'appInfo/app/getAgreementByMobileType'
      const { data } = await api.getProtocolDetail(url, { agreementType: type, mobileType })
      if (data) {
        this.content = data.agreementDoc
        this.name = data.agreementName
      }
    }
  }
}
</script>
<style scoped>
.section {
  padding: 15px;
}
.content {
  word-break: break-all;
}
.content p {
  margin: 10px 0;
  word-break: break-all;
}
.name {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
</style>
<style lang="scss">
.content img {
  display: block;
  text-align: center;
  max-width: 100%;
  cursor: pointer;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// protocol.vue?1d2c87e6